var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/TopNav/TopNavDesktop.jinja"] = require( "front/components/TopNav/TopNavDesktop.jinja" );
dependencies["front/components/TopNav/TopNavMobile.jinja"] = require( "front/components/TopNav/TopNavMobile.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/TopNav/TopNav.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/TopNav/TopNav.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
env.getTemplate("front/components/TopNav/TopNavDesktop.jinja", false, "assets/app/front/components/TopNav/TopNav.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "TopNavDesktop")) {
var t_7 = t_4.TopNavDesktop;
} else {
cb(new Error("cannot import 'TopNavDesktop'")); return;
}
context.setVariable("TopNavDesktop", t_7);
output += "\n";
env.getTemplate("front/components/TopNav/TopNavMobile.jinja", false, "assets/app/front/components/TopNav/TopNav.jinja", false, function(t_9,t_8) {
if(t_9) { cb(t_9); return; }
t_8.getExported(function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
if(Object.prototype.hasOwnProperty.call(t_8, "TopNavMobile")) {
var t_11 = t_8.TopNavMobile;
} else {
cb(new Error("cannot import 'TopNavMobile'")); return;
}
context.setVariable("TopNavMobile", t_11);
output += "\n\n<header class=\"TopNav\">\n\n    <div class=\"TopNav-desktopWrapper\">\n        ";
output += runtime.suppressValue((lineno = 8, colno = 22, runtime.callWrap(t_7, "TopNavDesktop", context, [runtime.makeKeywordArgs({"request": runtime.contextOrFrameLookup(context, frame, "request"),"data": {},"page": runtime.contextOrFrameLookup(context, frame, "page")})])), env.opts.autoescape);
output += "\n    </div>\n\n    <div class=\"TopNav-mobileWrapper\">\n        ";
output += runtime.suppressValue((lineno = 12, colno = 21, runtime.callWrap(t_11, "TopNavMobile", context, [runtime.makeKeywordArgs({"request": runtime.contextOrFrameLookup(context, frame, "request"),"data": {},"page": runtime.contextOrFrameLookup(context, frame, "page")})])), env.opts.autoescape);
output += "\n    </div>\n\n</header>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/TopNav/TopNav.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/TopNav/TopNav.jinja
// module id = 519
// module chunks = 0